(function () {
  if (window.__hdtSizeChartCustomInit) return;
  window.__hdtSizeChartCustomInit = true;

  // --- Inch / CM tab switching (ARIA tablist: role, aria-selected, aria-hidden, roving tabindex) ---
  function activateUnit(unitTab, unit) {
    unitTab.querySelectorAll('button[data-size-chart-unit]').forEach(function (button) {
      var isActive = button.getAttribute('data-size-chart-unit') === unit;
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    var panels = unitTab.parentElement && unitTab.parentElement.querySelector('[data-size-chart-panels]');
    if (!panels) return;
    panels.querySelectorAll('[data-size-chart-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-size-chart-panel') === unit;
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      panel.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  }

  function onUnitClick(event) {
    var unitButton = event.target.closest('button[data-size-chart-unit]');
    if (!unitButton) return;
    var unit = unitButton.getAttribute('data-size-chart-unit');
    if (!unit) return;
    var unitTab = unitButton.closest('[data-size-chart-units]');
    if (!unitTab) return;
    activateUnit(unitTab, unit);
  }

  document.addEventListener('click', onUnitClick);

  // MOXIE: WCAG 2.1.1 — arrow-key roving tabindex navigation between unit tabs
  function onUnitKeydown(event) {
    var unitTab = event.target.closest('[data-size-chart-units]');
    if (!unitTab) return;
    var buttons = Array.from(unitTab.querySelectorAll('button[data-size-chart-unit]'));
    if (!buttons.length) return;
    var currentIndex = buttons.indexOf(document.activeElement);
    if (currentIndex < 0) return;

    var targetIndex = -1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      targetIndex = (currentIndex + 1) % buttons.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      targetIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    } else if (event.key === 'Home') {
      event.preventDefault();
      targetIndex = 0;
    } else if (event.key === 'End') {
      event.preventDefault();
      targetIndex = buttons.length - 1;
    }

    if (targetIndex >= 0) {
      var targetButton = buttons[targetIndex];
      targetButton.focus();
      activateUnit(unitTab, targetButton.getAttribute('data-size-chart-unit'));
    }
  }

  document.addEventListener('keydown', onUnitKeydown);

  // --- MOXIE: JSON table builder ---
  function buildSizeTable(container) {
    var raw = container.getAttribute('data-size-json');
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }

    var table = container.querySelector('table');
    if (!table) return;

    var caption = table.querySelector('caption');
    if (caption && data.title) caption.textContent = data.title;

    var headerRow = table.querySelector('thead tr');
    if (headerRow) {
      var ths = '<th scope="col" tabindex="0">Size</th>';
      (data.columns || []).forEach(function (col) {
        ths += '<th scope="col" tabindex="0">' + col + '</th>';
      });
      headerRow.innerHTML = ths;
    }

    var tbody = table.querySelector('tbody');
    if (tbody) {
      var rows = '';
      (data.rows || []).forEach(function (row) {
        var label = row.label || '';
        if (data.unit) label += '<br><span class="moxie-size-guide__unit">(' + data.unit + ')</span>';
        var tds = '<th scope="row" tabindex="0">' + label + '</th>';
        (row.values || []).forEach(function (val) { tds += '<td tabindex="0">' + val + '</td>'; });
        rows += '<tr>' + tds + '</tr>';
      });
      tbody.innerHTML = rows;
    }
  }

  // --- MOXIE: Tab order — InchBtn → InchCells → CMBtn → CMCells → salida ---
  function setupFocusOrder(unitTabEl) {
    if (unitTabEl.dataset.moxieFocusOrder) return;
    unitTabEl.dataset.moxieFocusOrder = 'true';

    var container = unitTabEl.parentElement;
    if (!container) return;
    var panelsEl = container.querySelector('[data-size-chart-panels]');
    if (!panelsEl) return;

    var inchBtn = unitTabEl.querySelector('[data-size-chart-unit="inches"]');
    var cmBtn   = unitTabEl.querySelector('[data-size-chart-unit="centimeters"]');

    function getCells(unit) {
      var panel = panelsEl.querySelector('[data-size-chart-panel="' + unit + '"]');
      if (!panel) return [];
      return Array.from(panel.querySelectorAll('td[tabindex="0"], th[tabindex="0"]'));
    }

    function switchUnit(unit) {
      var btn = unitTabEl.querySelector('[data-size-chart-unit="' + unit + '"]');
      if (btn) btn.click();
    }

    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var active = document.activeElement;
      var inchCells = getCells('inches');
      var cmCells   = getCells('centimeters');

      if (!e.shiftKey) {
        // Inch btn → primera celda tabla Inches
        if (active === inchBtn && inchCells.length) {
          e.preventDefault();
          inchCells[0].focus();
        // Última celda Inches → CM btn
        } else if (inchCells.length && active === inchCells[inchCells.length - 1] && cmBtn) {
          e.preventDefault();
          cmBtn.focus();
        // CM btn → primera celda tabla CM (cambia panel)
        } else if (active === cmBtn && cmCells.length) {
          e.preventDefault();
          switchUnit('centimeters');
          requestAnimationFrame(function () {
            var cells = getCells('centimeters');
            if (cells.length) cells[0].focus();
          });
        }
        // Última celda CM → Tab continúa naturalmente fuera del chart

      } else {
        // Shift+Tab: primera celda Inches → Inch btn
        if (inchCells.length && active === inchCells[0] && inchBtn) {
          e.preventDefault();
          inchBtn.focus();
        // Shift+Tab: CM btn → última celda Inches (vuelve al panel Inches)
        } else if (active === cmBtn && inchCells.length) {
          e.preventDefault();
          switchUnit('inches');
          requestAnimationFrame(function () {
            var cells = getCells('inches');
            if (cells.length) cells[cells.length - 1].focus();
          });
        // Shift+Tab: primera celda CM → CM btn
        } else if (cmCells.length && active === cmCells[0] && cmBtn) {
          e.preventDefault();
          cmBtn.focus();
        }
        // Shift+Tab: Inch btn → Shift+Tab continúa naturalmente fuera del chart
      }
    });
  }

  // --- Init ---
  function initSizeTables(root) {
    (root || document).querySelectorAll('[data-size-json]').forEach(buildSizeTable);
    (root || document).querySelectorAll('[data-size-chart-units]').forEach(setupFocusOrder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSizeTables(); });
  } else {
    initSizeTables();
  }
  document.addEventListener('shopify:section:load', function (e) { initSizeTables(e.target); });
})();
